import { createSlice } from '@reduxjs/toolkit';

interface UploadState {
  profileImageUploaded: boolean;
}

const initialState: UploadState = {
  profileImageUploaded: false,
};

const uploadSlice = createSlice({
  name: 'upload',
  initialState,
  reducers: {
    setProfileImageUploaded: (state, action) => {
      state.profileImageUploaded = action.payload;
    },
    resetUploadState: (state) => {
      state.profileImageUploaded = false;
    }
  }
});

export const { setProfileImageUploaded, resetUploadState } = uploadSlice.actions;
export default uploadSlice.reducer;
